import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "title-container"
};
var _hoisted_2 = {
  key: 0,
  class: "title-tip"
};
var _hoisted_3 = {
  key: 1,
  class: "title-list"
};
var _hoisted_4 = {
  key: 0,
  class: "ribbon"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "right"
};
var _hoisted_7 = {
  key: 2
};
import { ref, watch, onMounted } from 'vue';
import { getUserDecorationList, updateTitle } from "../../api/user";
import { MessagePlugin } from 'tdesign-vue-next';
export default {
  __name: 'titleDialog',
  props: {
    titleVisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:titleVisible', 'update'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var visible = ref(props.titleVisible);
    var emit = __emit;
    var currentTitleId = ref(null);
    var titleList = ref([]);
    var handleWear = function handleWear(item) {
      currentTitleId.value = item.exchangeId;
      handleTitle(item);
    };
    var handleTakeOff = function handleTakeOff() {
      currentTitleId.value = null;
      handleTitle();
    };
    var closeDialog = function closeDialog() {
      visible.value = false;
      emit('update:titleVisible', false);
      emit('close');
    };
    var handleTitle = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var item,
          exchangeId,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              item = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              exchangeId = item.exchangeId;
              _context.n = 1;
              return updateTitle(exchangeId);
            case 1:
              emit('update', item);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function handleTitle() {
        return _ref2.apply(this, arguments);
      };
    }();
    var initData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, result, currentTitle;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getUserDecorationList();
            case 1:
              res = _context2.v;
              console.log(res);
              if (res.data.code === 0) {
                result = res.data.data;
                console.log(result);
                titleList.value = result.titleList || [];
                currentTitle = result.titleList.find(function (v) {
                  return v.isSelect;
                }) || {};
                console.log(currentTitle);
                currentTitleId.value = currentTitle.exchangeId;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function initData() {
        return _ref3.apply(this, arguments);
      };
    }();
    watch(function () {
      return props.titleVisible;
    }, function (newValue) {
      console.log(newValue, 'newValue');
      visible.value = newValue;
    });
    onMounted(function () {
      initData();
    });
    return function (_ctx, _cache) {
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        header: "修改称号",
        width: "600px",
        visible: visible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return visible.value = $event;
        }),
        onClose: closeDialog,
        footer: null
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [titleList.value && titleList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 佩戴称号将在首页、个人资料等处展示 ")) : _createCommentVNode("", true), titleList.value && titleList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(titleList.value, function (item) {
            return _openBlock(), _createElementBlock("div", {
              key: item.exchangeId,
              class: "title-item"
            }, [currentTitleId.value === item.exchangeId ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 已佩戴 ")) : _createCommentVNode("", true), _createElementVNode("img", {
              src: item.imgUrl,
              class: "title-img"
            }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [currentTitleId.value !== item.exchangeId ? (_openBlock(), _createBlock(_component_t_button, {
              key: 0,
              theme: "primary",
              variant: "outline",
              onClick: function onClick($event) {
                return handleWear(item);
              }
            }, {
              default: _withCtx(function () {
                return _toConsumableArray(_cache[1] || (_cache[1] = [_createTextVNode(" 佩戴 ", -1)]));
              }),
              _: 1
            }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_t_button, {
              key: 1,
              theme: "danger",
              variant: "outline",
              onClick: handleTakeOff
            }, {
              default: _withCtx(function () {
                return _toConsumableArray(_cache[2] || (_cache[2] = [_createTextVNode(" 取下 ", -1)]));
              }),
              _: 1
            }))])]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, _toConsumableArray(_cache[3] || (_cache[3] = [_createElementVNode("div", {
            class: "title-empty"
          }, "暂无称号", -1)]))))])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};